'use-client';

import type { FC } from 'react';
import type { ContentOptions } from '@/services/isomorphic/ContentService/IContentOptions';
import { useContent } from '@/react/hooks/useContent';
import { DirectContent } from '../DirectContent';

export interface IPrepareClientContentProps {
  /**
   * Content to render.
   */
  options: ContentOptions;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * This component allows you to fetch and render content.
 */
export const PrepareClientContent: FC<IPrepareClientContentProps> = ({
  options,
  handleLinkClick
}) => {
  const content = useContent(options);

  return (
    <>
      {content && (
        <DirectContent handleLinkClick={handleLinkClick} content={content} />
      )}
    </>
  );
};

export default PrepareClientContent;
